export default __webpack_public_path__ + "static/media/_percorsi_pos_spessa.f7192212.svg";